import React from 'react';
import SMORoomEditBaseFragment from './SMORoomEditBaseFragment';
import SMFormTextAreaWithError from 'components/dashboard/form/SMFormTextAreaWithError';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMORoomEditDescriptionFragmentAttachFilesView from './SMORoomEditDescriptionFragmentAttachFilesView';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';
import SMConst from 'lib/SMConst';

class SMORoomEditDescriptionFragment extends SMORoomEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      room: this.props.room,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      room : nextProps.room,
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  
  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">必須</span>スペースについて
          <span className="dashboard-title__supplement ml15">
            設備やサービスについて説明を記述してください。10文字以上800文字以内。
          </span>
        </h2>

        <SMFormTextAreaWithError name="description"
          value={this.state.room.description}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Room', 'description', this.props.errors)}
          placeholderText="Wi-Fi、ホワイトボード完備で会議からイベントまでご利用いただけます。その他必要な備品につきましては予約リクエスト時にお問い合わせください。"
          delegate={this} />


        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>飲食について
          <span className="dashboard-title__supplement ml15">
            800文字以内。
          </span>
        </h2>
        <SMFormTextAreaWithError name="food_description"
          value={this.state.room.food_description}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Room', 'food_description', this.props.errors)}
          placeholderText="飲食持ち込み可、ケータリングもオプションで承っております。"
          delegate={this} />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>後片付け・ゴミについて
          <span className="dashboard-title__supplement ml15">
            800文字以内。
          </span>
        </h2>
        <SMFormTextAreaWithError name="trash_description"
          value={this.state.room.trash_description}
          options={{className: 'form-textarea w700 h80',}}
          errorText={SMFormatHelper.errorText('Room', 'trash_description', this.props.errors)}
          placeholderText="瓶、缶類の分別をお願いいたします。回収は45L袋1つ500円（税込）とさせていただき、撤収時の精算になります。"
          delegate={this} />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>PDFファイル
          <span className="dashboard-title__supplement ml15">
            スペースの紹介、利用方法などを記載したPDFファイルをアップロードすることができます。
          </span>
        </h2>
        <SMORoomEditDescriptionFragmentAttachFilesView items={this.props.room.attach_files}
          delegate={this}
          errors={this.props.errors} />
        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>
        </div>
        <SMOAcademyLinkBaloonView displayPlace={SMConst.AcademyLinkDisplayPlace.RoomDiscription} isCurrent={this.state.isCurrent} />
      </div>
    );
  }
}

SMORoomEditDescriptionFragment.defaultProps = {
  errors: [],
};
export default SMORoomEditDescriptionFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditDescriptionFragment.jsx